import { render, staticRenderFns } from "./ExcelPaste.vue?vue&type=template&id=54a7c383"
import script from "./ExcelPaste.vue?vue&type=script&lang=js"
export * from "./ExcelPaste.vue?vue&type=script&lang=js"
import style0 from "./ExcelPaste.vue?vue&type=style&index=0&id=54a7c383&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports